// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"989f1bfe","806":"3c91ab9c"}[chunkId] + ".chunk.js";
};